/*
 * @Author: Teemo Ding
 * @Date: 2022-04-17 15:17:17
 * @LastEditTime: 2022-04-29 10:42:11
 * @LastEditors: Teemo Ding
 * @FilePath: /unifyxp-v2-store-portal/src/pages/Analytics/ReportsDetail/Components/SendToEmail/index.tsx
 */
import {
  Input,
  Label,
  ModalFooter,
  RadioGroup,
  RadioItem,
} from '@/src/components/Antd';
import ItemWrapper from '@/src/constrains/SalesChannelPreviewPageComponents/OverwriteItemWrapper';
import { unique } from '@/src/tools/helper';
import { IExportFormat } from '@/src/types/common/report';
import { Form } from 'antd';
import { cloneDeep } from 'lodash';
import React, { Fragment, useState } from 'react';
import Tags from 'src/components/Tags/Tags';
import { useI18n } from 'src/hooks/useRouterChange';
import { emailReg } from 'src/tools/regExp';
import { i18nGet } from 'src/tools/tools';
import css from './css.module.less';

const SendToEmail = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const { onCancel, onConfirm } = props;
  const [form] = Form.useForm();
  const [emailList, setEmailList] = useState([]);
  const regBreak = new RegExp(/[,｜\s｜，|,]+/g);

  const tagClose = (e, index) => {
    const mobileListCopy = cloneDeep(emailList);
    mobileListCopy.splice(index, 1);
    setEmailList(mobileListCopy);
    const emailListCopy = cloneDeep(emailList);
    emailListCopy.splice(index, 1);
    setEmailList(emailListCopy);
  };

  const handleEmailChange = (value) => {
    if (regBreak.test(value)) {
      handleEmailBreak(value);
    }
  };
  const handleEmailBreak = (value) => {
    if (value) {
      const emailListCopy = cloneDeep(emailList);
      const e = value.replace(regBreak, '');
      if (emailReg.test(e)) {
        emailListCopy.push(e);
        setEmailList(unique(emailListCopy));
        form.setFieldsValue({
          email: '',
        });
      }
    }
  };
  const handlePressEnter = (e) => {
    e.preventDefault();
    handleEmailBreak(e.target.value);
  };
  return (
    <Fragment>
      <Form
        name='sendToEmail'
        form={form}
        onFinish={(values) =>
          onConfirm({ emails: emailList, format: values.exportAs })
        }
        className={css.formContain}>
        <ItemWrapper
          title={getI18n('reports.reportdetailcomponents.sendToEmail.title')}
          rightSubTitle={getI18n(
            'reports.reportdetailcomponents.sendToEmail.rightsubtitle',
          )}>
          <Form.Item name='email' className={css.email}>
            <Input
              size='large'
              onChange={handleEmailChange}
              onPressEnter={handlePressEnter}
              disabled={(emailList || []).length === 10}
            />
          </Form.Item>{' '}
          <Tags onClose={tagClose} data={emailList} />
        </ItemWrapper>

        <Form.Item
          label={
            <Label
              title={getI18n(
                'reports.reportdetailcomponents.sendToEmail.export_title',
              )}
            />
          }
          name='exportAs'
          initialValue={IExportFormat.Excel}
          labelCol={{ span: 24 }}>
          <RadioGroup className={css.radioGroup}>
            <RadioItem value={IExportFormat.Excel}>
              {getI18n(
                'reports.reportdetailcomponents.sendToEmail.excel_workbook',
              )}
            </RadioItem>
            <RadioItem value={IExportFormat.CSV}>
              {getI18n('reports.reportdetailcomponents.sendToEmail.csv')}
            </RadioItem>
          </RadioGroup>
        </Form.Item>
      </Form>
      <ModalFooter
        onCancel={onCancel}
        okText={getI18n('reports.reportdetailcomponents.sendToEmail.send')}
        onOk={() => form.submit()}
      />
    </Fragment>
  );
};

export default SendToEmail;
